import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {ifloorplanStateAdd} from '../redux/actions/actions';
import {updateNewPlan} from '../serverRequests/requests';

const EditTextBlock = (props) => {
    const ifloorplanObj = props.ifloorplanNowState;
    const [text, setText] = useState(ifloorplanObj.address);
    const [textSize, ] = useState([1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6]);
    let screenSizeRatio = window.innerWidth/(window.innerHeight-46);
    let screenWidth = screenSizeRatio<1.7777 ? window.innerWidth*99/100 : (window.innerHeight*99/100-80)*1.7777;
    const placeHolderText = 'Enter property address';

    const [inputStyle, setInputStyle] = useState({
        fontWeight: ifloorplanObj.addressFontWeight,
        fontStyle: ifloorplanObj.addressFontStyle,
        fontSize: `${ifloorplanObj.addressFontSize * props.viewHeight / 100}px`,
        fontFamily: ifloorplanObj.addressFontFamily,
        color: ifloorplanObj.textColor,
        width: ifloorplanObj.addressInputWidth,
        height: ifloorplanObj.addressInputHeight
    });
    const [divStyle, setDivStyle] = useState({
        fontWeight: ifloorplanObj.addressFontWeight,
        fontStyle: ifloorplanObj.addressFontStyle,
        fontSize: `${ifloorplanObj.addressFontSize * props.viewHeight / 100}px`,
        fontFamily: ifloorplanObj.addressFontFamily,
    });

    const [opacitySize, setOpacitySize] = useState('none');
    const [opacityFont, setOpacityFont] = useState('none');
    const [isBlockVisible, setBlockVisible] = useState(false); //is text editor block visible or not
    const [latLong, setLatLong] = useState("");
    const [mouseDown, setMouseDown] = useState(false);
    const [mouseMove, setMouseMove] = useState(false);
    const fontFamily = {
        'IBM Plex Serif, serif': 'IBM Plex Serif',
        'Roboto, sans-serif': 'Roboto',
        'DM Sans, sans-serif': 'DM Sans',
        'Verdana, Arial, Helvetica, sans-serif': 'Arial',
        'Lucida Console, Courier, monospace': 'Courier',
        'cursive': 'Cursive',
        'fantasy': 'Fantasy',
    }

    const updateMainState = () => {
        let newState = JSON.parse(JSON.stringify(ifloorplanObj));
        newState.addressFontFamily = inputStyle.fontFamily;
        newState.addressFontSize = inputStyle.fontSize.slice(0, -2) * 100 / props.viewHeight; //without "vh" in the end
        newState.addressFontStyle = inputStyle.fontStyle;
        newState.addressFontWeight = inputStyle.fontWeight;
        newState.addressInputWidth = inputStyle.width;
        newState.addressInputHeight = inputStyle.height;
        newState.textColor = inputStyle.color;
        newState.address = text;
        props.ifloorplanStateAdd(newState);
    };

    useEffect(() => {
        setText(props.ifloorplanNowState.address);
    }, [props.ifloorplanNowState]);

    useEffect(() => {
        setInputStyle({
            ...inputStyle,
            fontSize: `${ifloorplanObj.addressFontSize * props.viewHeight / 100}px`,
        });
    }, [props.viewHeight])

    useEffect(() => {
        updateMainState();
    }, [text, textSize, inputStyle]);

    const changeSize = (value) => {
        setInputStyle({
            ...inputStyle,
            fontSize: `${value * props.viewHeight / 100}px`,
            height: props.viewHeight * value / 100 + 10,
        });

        setDivStyle({
            ...divStyle,
            fontSize: `${value * props.viewHeight / 100}px`
        })
        setOpacitySize('none');
    };

    useEffect(() => {
        console.log(inputStyle, inputStyle.fontSize.slice(0,-2));
        let div = document.querySelector('.input-buffer')
        let input = document.querySelector('#text_input')
        div.innerHTML = input.value ? input.value : placeHolderText;
        const parentBlock = document.getElementsByClassName('dnd-wrapper')[0].getBoundingClientRect();
        setInputStyle({
            ...inputStyle, 
            width: Math.min(div.offsetWidth+10, parentBlock.width + parentBlock.left - input.getBoundingClientRect().left), 
            height: inputStyle.fontSize.slice(0,-2)+15 
        });
    }, [divStyle, text])

    const changeFont = (value) => {
        setInputStyle({
            ...inputStyle,
            fontFamily: value
        });
        setDivStyle({
            ...divStyle,
            fontFamily: value
        });
        setOpacityFont('none');
    };

    const handleChange = (event) => {
        if (isBlockVisible)
            setText(event.target.value);
    };

    useEffect(() => {
        setInputStyle({
            ...inputStyle,
            color: props.ifloorplanNowState.textColor
        });
        setDivStyle({
            ...divStyle,
            color: props.ifloorplanNowState.textColor
        });
    }, [props.ifloorplanNowState.textColor]);

    useEffect(() =>{
        Save();
    }, [latLong]);

    const Save = () => {
        let newState = JSON.parse(JSON.stringify(ifloorplanObj));
        if(latLong != ""){
            newState.lat_long = latLong;
            updateNewPlan(newState)
                .then((data)=>{
                    props.ifloorplanStateAdd(data[0]); //update state ifloorplan
                })
        }
    }
    return (
        <div className='edit-text-block'>
            <div className="wrap_text_editor_main"
                 style={{
                    display: isBlockVisible ? "block" : "none",
                    top: (props.rndState && props.rndState.y > 50) ? '-30px' : `${inputStyle.height + 15}px`,
                    left: props.rndState ? Math.min(0, screenWidth - 370 - props.rndState.x) : 0
                }}>
                <div className='edit-font-wrapper'>
                    <div className='font-style'>
                        <ul style={{
                            display: opacityFont,
                            transform: ifloorplanObj.addressPosition_y>50 ? "translateY(-130px)" : "translateY(15px)"
                        }}>
                            {Object.entries(fontFamily).map((key, value) => {
                                return (<li key={key} style={{outline: inputStyle.fontFamily===key[0] ? "solid 1px" : "none"}} onClick={() => {changeFont(key[0])}}>{key[1]}</li>)
                            })}
                        </ul>
                        <div onClick={() => setOpacityFont(opacityFont === 'none' ? 'block' : 'none')}>
                            {fontFamily[inputStyle.fontFamily]}
                            <i className="fas fa-caret-down"></i>
                        </div>
                    </div>

                    <div className='font-size'>
                        <div onClick={() => setOpacitySize(opacitySize === 'none' ? 'block' : 'none')}>
                            <i className="fas fa-text-height"></i>
                            <i className="fas fa-caret-down"></i>
                        </div>
                        <ul style={{
                            display: opacitySize,
                            transform: ifloorplanObj.addressPosition_y>50 ? "translateY(-195px)" : "none"
                        }}>
                            {textSize.map(size => {
                                return (
                                    <li style={{ outline: size===parseFloat(inputStyle.fontSize) ? "solid 1px" : "none"}} key={size} onClick={() => changeSize(size)}> {size} </li>
                                ) 
                            }).reverse()}
                        </ul>
                    </div>

                    <div className={inputStyle.fontWeight === 'bold' ? 'bold-style active' : 'bold-style'}
                         onClick={() => {
                             setInputStyle({
                                ...inputStyle,
                                fontWeight: inputStyle.fontWeight === 'bold' ? 'normal' : 'bold'
                            });
                            setDivStyle({
                                ...divStyle,
                                fontWeight: inputStyle.fontWeight === 'bold' ? 'normal' : 'bold'
                            })
                        }}>
                        <i className="fas fa-bold"></i>
                    </div>
                    <div className={inputStyle.fontStyle === 'italic' ? 'italic-style active' : 'italic-style'}
                         onClick={() => {
                             setInputStyle({
                                ...inputStyle,
                                fontStyle: inputStyle.fontStyle === 'italic' ? 'normal' : 'italic'
                            });
                            setDivStyle({
                                ...divStyle,
                                fontStyle: inputStyle.fontStyle === 'italic' ? 'normal' : 'italic'
                            })
                        }}>
                        <i className="fas fa-italic"></i>
                    </div>
                    <div style={{border: "none"}}>
                        <input type="color" value={inputStyle.color}
                            onChange={(e)=> setInputStyle({
                                ...inputStyle,
                                color: e.target.value,
                            })}></input>
                    </div>
                    <div  
                        onClick={async () => {
                            window.open(`https://maps.google.com/?q=${text}`);
                        }}>
                        Search
                    </div>
                    <div
                        onClick={() => {
                            setBlockVisible(false);
                            document.getElementsByClassName("wrap_text_editor_main")[0].style.display = "none";
                        }}>
                        Done
                    </div>

                </div>
            </div>

            <form>
                <input id="text_input" 
                    style={{
                        ...inputStyle,
                        border: isBlockVisible ? "1px solid #80808066" : "none",
                        cursor: isBlockVisible ? "auto" : "all-scroll",
                        caretColor: isBlockVisible ? "auto" : "rgba(0,0,0,0)",
                    }}
                    type='text'
                    value={text}
                    placeholder={placeHolderText}
                    onChange={handleChange}
                    onBlur={async () => {
                        if(text === "") return ;
                        const location = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${text}&key=AIzaSyBj_5jx0TD50Wy1FFqsq9Q7zxiGT6Vvcv4`)
                        .then(response => response.json());
                        if(location.results[0])
                            setLatLong(Object.values(location.results[0].geometry.location).join(" "));
                    }}
                    autoComplete="off"
                    onMouseDown={() => {setMouseDown(true)}}
                    onMouseMove={() => {setMouseMove(mouseDown)}}
                    onMouseUp={() => {
                            if(!mouseMove){
                                setBlockVisible(true);
                                document.getElementsByClassName("wrap_text_editor_main")[0].style.display = "block";
                            }
                            setMouseDown(false);
                            setMouseMove(false);
                    }}
                />
                <div className="input-buffer" style={divStyle}></div>
            </form>
        </div>
    )
}

const putState = (state) => {
    return {
        ifloorplanNowState: state.ifloorplanNowState,
        textColor: state.textColor,
    }
}

const putActions = (dispatch) => {
    return {
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan))
    }
}

export default connect(putState, putActions)(EditTextBlock);